export const regex = {
  regex: {
    currency: /^(?![,.]+$)(?:0|([1-9][0-9]{1,2}|[1-9]{1,3})(?:\.\d{3}){0,3}|[1-9]\d{0,12})(?:\,\d{1,2})?$/, // max 999.999.999.999 || 999999999999
    numberWithTwoDecimalAndTwoEntires: /^(\d{1,2})(?:\,\d{1,2})?$/,
    currency2: /^(?![,.]+$)(?:0|([1-9][0-9]{1,2}|[1-9]{1,3})(?:\.\d{3}){0,3}|[1-9]\d{0,9})(?:\,\d{1,2})?$/,// versione a 999.999.999,99 || 99999999
    currencyNoNegative: /^(?:\d{1,3}(?:\.\d{3})+|\d+)(?:,\d{1,2})?$/,
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/,
    onlyNumbers: /^([0-9]\d*)?$/,
    onlyNumbersWithMaxOneDecimal: /^((\d|[1-9]\d+)(\,\d{1})?|\,\d{1})$/,
    codiceFiscale: /^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$/,
    onlyLetters: /^[a-zA-Z\-' *]*$/,
    votazione: /^[0-9]{1,3}\/[0-9]{1,3}$/,
    telefono: /^[+]?[0-9]+$/,
  },
};
